import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { App, Button, Card, Grid, Typography } from "antd";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import IntangibleAssetLedgerFilters from "./components/IntangibleAssetLedgerFilters";
import IntangibleAssetLedgerTable from "./components/IntangibleAssetLedgerTable";

const { Title } = Typography;

const IntangibleAssetLedger = () => {
  const navigate  = useNavigate();
  const { message } = App.useApp();
  const screens   = Grid.useBreakpoint();
  const { list }  = useSelector((state) => state.intangibleAssetLedger);
  const reportRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Intangible Asset Ledger Report",
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate("/reports")}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }}>
                Intangible Asset Ledger
              </Title>
            </div>
          }
          extra={
            list.length > 0 && (
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            )
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        >
          <IntangibleAssetLedgerFilters messageApi={message} />
        </Card>

        <Card className="shadow-md rounded-xl">
          <IntangibleAssetLedgerTable />
        </Card>
      </App>

      {/* Hidden print view */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <IntangibleAssetLedgerTable ref={reportRef} printMode />
      </div>
    </div>
  );
};

export default IntangibleAssetLedger;